import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { isDefined } from '@ngneat/transloco';
import { AuthService } from 'app/core/auth/auth.service';
import { UserService } from 'app/core/user/user.service';
import { filter, map, of, switchMap, take, tap } from 'rxjs';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);

    const userService = inject(UserService);

    // Check the authentication status
    return inject(AuthService).check().pipe(
        switchMap((authenticated) => {
            // If the user is not authenticated...
            if (!authenticated) {
                // Redirect to the sign-in page with a redirectUrl param
                const redirectURL = state.url === '/sign-out' ? '' : `redirectURL=${state.url}`;
                const urlTree = router.parseUrl(`sign-in?${redirectURL}`);

                return of(urlTree);
            } else {
                if (state.url == '/dashboard') {
                    return userService.get().pipe(filter(x => isDefined(x)), take(1), tap(user => {
                        router.navigate([`/user/detail/${user.id}`], {})
                    }), map(_ => true))
                }
            }

            // Allow the access
            return of(true);
        }),
    );
};
